module.exports = __webpack_public_path__ + "img/BlendBuff-ChainCoef.69b98e06.png";